import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { media } from '../styles/Mixin';

const Text = styled.span`
  ${media.deskTop`
    font-size:${(props) => props.theme.deskFontSize};
  `}
  ${media.mobile`
    font-size:${(props) => props.theme.mobileFontSize};
  `}
`;

const NormalText = ({ text, className, onClick }) => (
  <Text className={className} onClick={onClick}>
    {text}
  </Text>
);

NormalText.propTypes = {
  text: PropTypes.string.isRequired
};

export default NormalText;
